import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Toaster } from "./components/ui/toast";
import { setupI18n } from "./i18n";
import { ApiRequestError } from "./lib/api";
import { router } from "./router";
import "./styles/app.css";

setupI18n();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, err) => !(err instanceof ApiRequestError && err.status < 500) && count < 2,
      refetchOnWindowFocus: true,
      staleTime: 5_000,
    },
  },
});

// Sentry (SPA): DSN arrives at runtime from /api/config.
void fetch("/api/config")
  .then((r) => (r.ok ? r.json() : null))
  .then((cfg: { sentryDsn?: string | null; environment?: string } | null) => {
    if (cfg?.sentryDsn)
      Sentry.init({
        dsn: cfg.sentryDsn,
        environment: cfg.environment,
        sendDefaultPii: false,
        tracesSampleRate: 0,
      });
  })
  .catch(() => {});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster />
    </QueryClientProvider>
  </StrictMode>,
);
